/**
 * RiderInfoDetailPage Component
 * 라이더 상세정보 페이지
 */
import React, { useCallback } from 'react';
import { useRiderInfoDetail } from '../hooks/useRiderInfoDetail';
import BasicInfoSection from './BasicInfoSection';
import AccountInfoSection from './AccountInfoSection';
import RiderTypeSection from './RiderTypeSection';
import DeductionTable from './DeductionTable';
import '../styles/RiderInfoDetailPage.css';

interface RiderInfoDetailPageProps {
    riderId?: string;
}

const RiderInfoDetailPage: React.FC<RiderInfoDetailPageProps> = ({ riderId }) => {
    const {
        loading,
        error,
        riderInfo,
        accountInfo,
        setAccountInfo,
        deductions,
        bankOptions,
        handleSaveAccount,
        handleAccountNumberChange,
        handleAccountHolderChange,
        riderTypes,
        riderTypeLoading,
        selectedRiderType,
        userType,
        handleRiderTypeChange,
        handleSaveRiderType
    } = useRiderInfoDetail(riderId);

    const isHeadquartersUser = userType === 'HEADQUARTERS';

    const handleBankChange = useCallback((value: string) => {
        setAccountInfo(prev => ({ ...prev, bank: value }));
    }, [setAccountInfo]);

    if (loading) {
        return (
            <div className="rider-info-detail-content">
                <div className="loading-container">
                    <div>로딩 중...</div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="rider-info-detail-content">
                <div className="error-container">
                    <div>오류: {error}</div>
                    <button
                        className="retry-button"
                        onClick={() => window.location.reload()}
                    >
                        다시 시도
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="rider-info-detail-content">
            <div className="page-header">
                <h1 className="page-title">라이더 상세정보</h1>
            </div>

            <BasicInfoSection riderInfo={riderInfo} />

            <AccountInfoSection
                accountInfo={accountInfo}
                bankOptions={bankOptions}
                onBankChange={handleBankChange}
                onAccountNumberChange={handleAccountNumberChange}
                onAccountHolderChange={handleAccountHolderChange}
                onSave={handleSaveAccount}
            />

            {isHeadquartersUser && (
                <RiderTypeSection
                    riderTypes={riderTypes}
                    selectedRiderType={selectedRiderType}
                    riderTypeLoading={riderTypeLoading}
                    onRiderTypeChange={handleRiderTypeChange}
                    onSave={handleSaveRiderType}
                />
            )}

            <DeductionTable deductions={deductions} />
        </div>
    );
};

export default RiderInfoDetailPage;
